module.exports = __webpack_public_path__ + "static/media/vegitables_70.d39153eb.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_70.csv
// module id = 658
// module chunks = 0